import React, { FunctionComponent, useContext } from "react";
import { CONSTANTS, IntlContext, useTranslate } from "../../../helpers";
import { buildAddress } from "../helpers";
import { PharmacyResultsType } from "../../../@types";

export const FormattedResultsMessage: FunctionComponent<{
  page: number;
  pharmacyResults?: PharmacyResultsType;
  previousNameSearch: string;
  totalPharmacies: number;
}> = ({ page, pharmacyResults, previousNameSearch, totalPharmacies }) => {
  const fm = useContext(IntlContext).formatMessage;
  const t = useTranslate();
  return (
    <div
      role="status"
      aria-live="polite"
      className="SelectPharmaciesPage__grayBottomBorder ds-u-padding-y--2 ds-u-padding-left--2 ds-u-md-padding-left--7"
    >
      {pharmacyResults && pharmacyResults.pharmacies.features.length > 0
        ? fm(
            { id: "pharm_selection.pharmacy_count" },
            {
              pharmacyLowerBound:
                CONSTANTS.pharmacySelection.pageCount * page + 1,
              pharmacyUpperBound:
                CONSTANTS.pharmacySelection.pageCount * page +
                pharmacyResults?.pharmacies.features.length,
              totalPharmacies,
              for: previousNameSearch
                ? fm(
                    { id: "pharm_selection.for" },
                    {
                      for: previousNameSearch,
                    }
                  )
                : "",
              address: fm(
                { id: "pharm_selection.near_address" },
                {
                  address: buildAddress(pharmacyResults.sourceAddress),
                }
              ),
            }
          ).replace(/\s+/gm, " ")
        : t("pharm_selection.showing_0_pharmacies")}
    </div>
  );
};
